import { useCallback, useEffect, useRef, useState } from 'react';

function useAutocompleteScroll(open: boolean, inputValue?: string) {
  // Refs for scroll management
  const selectedItemRef = useRef<HTMLDivElement | null>(null);
  const commandListRef = useRef<HTMLDivElement | null>(null);
  const [shouldScrollToSelected, setShouldScrollToSelected] = useState(false);

  // When the dropdown opens, set flag to trigger scrolling to selected item
  useEffect(() => {
    if (open) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShouldScrollToSelected(true);
    }
  }, [open]);

  // Reset scroll position when input value changes
  useEffect(() => {
    if (commandListRef.current && inputValue) {
      commandListRef.current.scrollTop = 0;
    }
  }, [inputValue]);

  // Scroll the selected item into view at the top when dropdown opens.
  // Uses setTimeout to ensure DOM is ready (handles portals/async rendering).
  const setSelectedItemRef = useCallback(
    (node: HTMLDivElement | null) => {
      selectedItemRef.current = node;
      if (node && shouldScrollToSelected) {
        setTimeout(() => {
          node.scrollIntoView({ block: 'start', behavior: 'auto' });
          setShouldScrollToSelected(false);
        }, 0);
      }
    },
    [shouldScrollToSelected]
  );

  const setCommandListRef = useCallback((node: HTMLDivElement | null) => {
    commandListRef.current = node;
  }, []);

  return {
    setSelectedItemRef,
    setCommandListRef,
  };
}

export { useAutocompleteScroll };
